import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import { colors, typography } from '../../styles/theme';

interface WhyPicloProps {
  visible: boolean;
  onClose: () => void;
}

export default function WhyPicloModal({ visible, onClose }: WhyPicloProps) {
  return (
    <BaseModal 
      visible={visible} 
      onClose={onClose}
      header={<Text style={modalStyles.headerText}>Why Piclo?</Text>}
      footer={(
        <HoverButton 
          style={modalStyles.secondaryButton} 
          textStyle={modalStyles.secondaryButtonText}
          onPress={onClose}
        >
          Close
        </HoverButton>
      )}
    >
      <View style={styles.container}>
        <Text style={styles.paragraph}>
          This app was inspired by someone I aspire to be more like: Piccolo the dog.
        </Text>

        <Text style={styles.paragraph}>
          Over time, we've captured hundreds of moments of him, and this app serves as a way to share them with the world.
        </Text>

        <Text style={styles.paragraph}>
          Every day, a new moment in Piccolo's life will be revealed, so check back often to see what he's up to.
        </Text>
      </View>
    </BaseModal>
  );
}

const styles = StyleSheet.create({
  container: { 
    marginBottom: 20 
  },
  paragraph: { 
    ...typography.body, 
    color: colors.text, 
    fontSize: 18,
    marginBottom: 20, 
    lineHeight: 26,
    textAlign: 'left'
  },
});
